import { MotorService } from './../services/motor.service';
import { Component, OnInit, Input } from '@angular/core';
import { RoomsService } from '../rooms/rooms.service';
import { Empresa } from '../model/empresa';

@Component({
  selector: 'app-header-rooms',
  templateUrl: './header-rooms.component.html',
  styleUrls: ['./header-rooms.component.css']
})
export class HeaderRoomsComponent implements OnInit {

  public empresa: Empresa;

  constructor(
    private readonly motorService: MotorService
  ) {
    this.motorService.empresaObservable.subscribe(empresa => this.empresa = empresa);
  }

  ngOnInit() {
  } 
  
}
